import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CWLayout from "../../../../changeOwnership/change/cwLayout";
import { Breadcrumb, Button, Col, Image, Row, Steps } from "antd";
import { _adr } from "../../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import Profile from "../../profile/profile";
import styles from "./CowReview.module.scss";
import { convertToJalaliWithoutTime, fileToBase64, formatMsisdn } from "../../../../../tools/tools";
import { date } from "yup";
import { useDealer } from "../../../../../tools/api";
import Loading from "../../../../auxiliary/loader/loading";

const CowReview = () => {
	const [t] = useTranslation("global");
	const formData = useSelector((state) => state?.from?.coownership);
	const { changeOwnerB2B } = useDealer();
	const nav = useNavigate();
	const [review, setReview] = useState({
		purchase: formData.purchase,
		profile: formData.profile,
		isVisibleDoc: false,
		documentFile: null,
		isLoading: false,
	});
	useEffect(() => {
		const initialGetFile = async () => {
			const tempDoc = await fileToBase64(review?.profile?.photo);
			setReview((rev) => ({ ...rev, documentFile: tempDoc }));
		};
		initialGetFile();
	}, []);
	console.log(formData);

	const submitHandler = async () => {
		try {
			setReview((rev) => ({ ...rev, isLoading: true }));
			const payload = {
				msisdn: review?.purchase?.inT_MSISDN,
				oldprofileinfoid: review?.purchase?.guD_ProfileInfoId,
				newprofileinfoid: review?.profile?.profileid,
				oldpurchaseproductid: review?.purchase?.guD_PurchaseProductId,
			};
			const response = await changeOwnerB2B(payload);
			if (response) {
				nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Final, {
					state: { ...response },
				});
			}
			setReview((rev) => ({ ...rev, isLoading: false }));
		} catch (error) {
			console.error(error);
			setReview((rev) => ({ ...rev, isLoading: false }));
		}
	};

	return (
		<>
			<CWLayout>
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
						/>
						<div className="title-page">
							<h3>{t("changeOwnerShip.ownership.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<Profile Profile={review.purchase} state />
							<br />
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={2}
											responsive
											items={[
												{
													title: "اطلاعات خریدار(حقیقی)",
												},
												{
													title: "آپلود مدرک شناسایی (حقیقی)",
												},
												{
													title: "بررسی نهایی",
												},
											]}
										/>
									</div>
								</div>
								<div className="cw-swap-document">
									<div className={styles.purchase_detail}>
										<h2 className={styles.page_title}>
											اطلاعات هویتی
											<Link to={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Profile}>
												<i className="icon-edit"></i>
											</Link>
										</h2>
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نوع مدرک شناسایی</div>
													<div className={styles.value}>{review?.profile?.txtDocumentType}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شماره مدرک شناسایی</div>
													<div className={styles.value}>
														<span dir="ltr">{review?.profile?.certno}</span>
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>تاریخ تولد</div>
													<div className={styles.value}>{convertToJalaliWithoutTime(review?.profile?.birthdate) || "-"}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام </div>
													<div className={styles.value}>{review?.profile?.fname}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام خانوادگی</div>
													<div className={styles.value}>{review?.profile?.lname}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>نام پدر</div>
													<div className={styles.value}>{review?.profile?.fathername}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>جنسیت</div>
													<div className={styles.value}>{review?.profile?.txtGender}</div>
												</Col>
												{!review?.profile?.isIran && (
													<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
														<div className={styles.label}>کشور</div>
														<div className={styles.value}>{review?.profile?.txtCountry}</div>
													</Col>
												)}

												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>پست الکترونیکی</div>
													<div className={styles.value}>
														<span dir="ltr">{review?.profile?.email || "-"}</span>
													</div>
												</Col>
											</Row>
										</div>
										<div className={styles.divider}></div>
										<h2 className={styles.page_title}>اطلاعات تماس </h2>
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شماره همراه </div>
													<div className={styles.value}>
														<span dir="ltr">0{formatMsisdn(review?.profile?.smsmobileno)}</span>
													</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>تلفن ثابت</div>
													<div className={styles.value}>{review?.profile?.tel}</div>
												</Col>
											</Row>
										</div>
										<div className={styles.divider}></div>
										<h2 className={styles.page_title}>آدرس</h2>
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>خیابان اصلی:</div>
													<div className={styles.value}>{review?.profile?.mainstreet}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>خیابان فرعی:</div>
													<div className={styles.value}>{review?.profile?.auxiliaryroad}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>کوچه:</div>
													<div className={styles.value}>{review?.profile?.alley}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شماره ساختمان:</div>
													<div className={styles.value}>{review?.profile?.buildingno}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>طبقه:</div>
													<div className={styles.value}>{review?.profile?.floor}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>واحد:</div>
													<div className={styles.value}>{review?.profile?.unit}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>کدپستی:</div>
													<div className={styles.value}>{review?.profile?.postalcode}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>استان:</div>
													<div className={styles.value}>{review?.profile?.txtProvince}</div>
												</Col>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>شهر:</div>
													<div className={styles.value}>{review?.profile?.txtCity}</div>
												</Col>
											</Row>
										</div>
										<div className={styles.divider}></div>
										<h2 className={styles.page_title}>تصویر مدرک شناسایی خریدار </h2>
										<div className={styles.page_body}>
											<Row>
												<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
													<div className={styles.label}>{review?.profile?.txtDocumentType || "مدرک شناسایی"}</div>
													<div className={styles.value}>
														<div className="show-document">
															<Button onClick={() => setReview((rev) => ({ ...rev, isVisibleDoc: true }))} type="link">
																بارگذاری شده
															</Button>
															<Image
																preview={{
																	visible: review.isVisibleDoc,
																	onVisibleChange: (value) => setReview((rev) => ({ ...rev, isVisibleDoc: value })),
																}}
																src={review.documentFile}
																style={{ display: "none" }}
															/>
														</div>
													</div>
												</Col>
											</Row>
										</div>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button form="frmDocument" key="submit" htmlType="submit" className="btn-normal btn-aptel" onClick={submitHandler}>
										بررسی و تایید نهایی
									</Button>
									<Button
										onClick={() => nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Profile)}
										className="btn-normal">
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
				<Loading isOpen={review?.isLoading} />
			</CWLayout>
		</>
	);
};

export default CowReview;
